jQuery(function($){
	
	
	  'use strict';
	  
	  jQuery('.toggles .button').on("click", function(e) {
	  	e.preventDefault();
		var $this = jQuery(this);
		var account = $this.data('twt_toggle');
		if(!$this.hasClass('active')) {
			jQuery('.toggles .button').removeClass('active');
			$this.addClass('active');
			
			jQuery('.twitter-carousel').addClass('invisible');
			jQuery('#'+account).removeClass('invisible');
			
			
		}
	  });
	
	  const TWITTER_FEED_ENDPOINT = window.twitter_feed.site_url + '/' + window.twitter_feed.endpoint;
	
	  var adjustTwitterCardHeights = function() {
		$('.twitter-feed').each( function() {
		  $(this).find('.js-twitter-feed-card').height($(this).height());
		});
		ResponsiveUtils.respondTo('medium',
			function() {
			  $('.twitter-feed').each( function() {
				$(this).find('.js-twitter-feed-card').height('auto');
				$(this).find('.js-twitter-feed-card').height($(this).height());
			  });
			},
			function() {
			  $('.twitter-feed').each( function() {
				$(this).find('.js-twitter-feed-card').height('auto');
			  });
			}
		);
	  }
	
	  $(window).on('resize', adjustTwitterCardHeights);
	
	  var getLatestTweets = function() {
		if(!$('.js-twitter-feed-track').length) return;
		var endpoint = TWITTER_FEED_ENDPOINT;
		$.ajax({
		  url : endpoint,
		  dataType: 'json',
		  success : function(response) {
			$('.js-twitter-feed-track').find('.js-loading').remove();
			
			for (var i = 0; i < response.length; i++) {
			  var tweet_url = response[i].tweet_url;
			  var content = response[i].content;
			  var date = response[i].date;
			  var from = response[i].account_name;
			  var media_url = response[i].media_url;
			  var tweet_like_url = response[i].tweet_like_url;
			  var tweet_retweet_url = response[i].tweet_retweet_url;
			  console.log(response[i]);
			  var tweetHtml = buildTweetCard(tweet_url, content, date, from, media_url, tweet_like_url, tweet_retweet_url);
			  $('.js-twitter-feed-track').append(tweetHtml);
			}
	
			adjustTwitterCardHeights();
		  },
		  error : function(response) {
		  }
		});
	  }
	
	  var buildTweetCard = function(tweet_url, content, date, from, media_url, tweet_like_url, tweet_retweet_url) {
		var html = '<div class="twitter-feed__card js-twitter-feed-card';
		if(media_url) {
		  html += ' with-img" ';
		  html += 'style="background-image:url(' + media_url + ')"';
		} else {
		  html += '"';
		}
		html += '>\
				<div class="twitter-feed__card-content js-twitter-card-content s-twitter-feed">\
					' + content + '\
				</div>\
				<div class="twitter-feed__card-byline">\
				  <a target="_blank" href="' + tweet_url + '" class="">\
						<span class="twitter-feed__card-date">' + date + '</span>\
						<span class="twitter-feed__card-from">@' + from + '</span>\
				  </a>\
				</div>\
				<div class="twitter-feed__card-icons">\
				  <a target="_blank" href="'+tweet_like_url+'" class="twitter-feed__heart-icon js-twitter-intent">\
					<i class="category-label__icon icon icon--like"></i>\
				  </a>\
				  <a target="_blank" href="'+tweet_retweet_url+'" class="twitter-feed__retweet-icon js-twitter-intent">\
					<i class="category-label__icon icon icon--retweet"></i>\
				  </a>\
				</div>\
			  </a>\
			</div>';
		return html;
	  }
	
	  function handleIntent(event , elem) {
		event.preventDefault();
		var src       =  $(elem).attr('href') ,
			windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes',
			width     = 550,
			height    = 420,
			winHeight = screen.height,
			winWidth  = screen.width,
			left, top;
	
		left = Math.round((winWidth / 2) - (width / 2));
		top = 0;
	
		if (winHeight > height) {
		  top = Math.round((winHeight / 2) - (height / 2));
		}
	
		window.open(src, 'intent', windowOptions + ',width=' + width +',height=' + height + ',left=' + left + ',top=' + top);
	  }
	
	  getLatestTweets();
	
	  $(document).on('click', '.js-twitter-intent' , function(event){handleIntent(event , this)} );
	
	});
	